module.exports = __webpack_public_path__ + "img/serviceVITODENS.86b89412.webp";